import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import Portlet from '../layout/Portlet';
import { getColumns } from './columns';
import { Spin, Table } from 'antd';
import FiltersList from 'components/tables/filters/FiltersList';
import { stringFilterComparator } from 'lib/TableHelpers';
import { filterData } from './filterData';

const GaragesList = ({
  clearFilters,
  fetchGarages,
  fetchingGarages,
  filters,
  garagesData,
  lang,
  location,
  regions,
  setFilter,
  taxOffices,
  user,
}) => {
  React.useEffect(() => {
    fetchGarages();
  }, []); //eslint-disable-line

  const columns = React.useMemo(() => getColumns(regions, taxOffices), [lang]); //eslint-disable-line

  React.useEffect(() => {
    if (Array.isArray(filters) && filters.length > 0) {
      const { Value: filterLocation } =
        filters.find(f => f.Name === 'forLocation') || {};
      if (!filterLocation || filterLocation !== location.pathname) {
        if (!!filterLocation) clearFilters();
        setFilter('forLocation', location.pathname);
      }
    }
  }, []); // eslint-disable-line

  // actual garage data that will be sent to table
  const filteredGarages = React.useMemo(() => {
    const filterFunc =
      Array.isArray(filters) && filters.length > 0
        ? garage =>
            filters
              .filter(x => x.Name !== 'forLocation')
              .every(f => {
                if (!f.Name) return false;
                return stringFilterComparator(garage[f.Name], f.Value);
              })
        : item => item;

    return (garagesData || []).filter(filterFunc);
  }, [garagesData, filters]);

  const columnsWidth = React.useMemo(
    () =>
      (columns || []).reduce(
        (sum, columnDef) =>
          sum + (typeof columnDef.width === 'number' ? columnDef.width : 0),
        200
      ),
    [columns]
  );

  return (
    <div>
      <h1 className="page-title">{I.t('GARAGES')}</h1>

      <Portlet bodyClassName="form-horizontal">
        <FiltersList
          filterData={filterData}
          filters={filters}
          setFilter={setFilter}
          location={location}
          regions={regions}
        />

        <hr className="clear" />

        <Spin spinning={fetchingGarages} size="large" tip="Loading...">
          <Table
            columns={columns}
            dataSource={filteredGarages}
            size="small"
            bordered={true}
            scroll={{
              x: columnsWidth,
            }}
          />
        </Spin>
      </Portlet>
    </div>
  );
};

export default GaragesList;
